import { render, staticRenderFns } from "./GPathAptitudeEdit.vue?vue&type=template&id=1b835afe&scoped=true"
import script from "./GPathAptitudeEdit.vue?vue&type=script&lang=js"
export * from "./GPathAptitudeEdit.vue?vue&type=script&lang=js"
import style0 from "./GPathAptitudeEdit.vue?vue&type=style&index=0&id=1b835afe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b835afe",
  null
  
)

export default component.exports